import React, { useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { Button } from "reactstrap";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import Datatable from "../CommonComponents/Datatable/Datatable";
import { CommunicationLogListData } from "../../helpers/renderData";
import CommunicationModal from "./Communicationmodal";
import {
  addCommunication,
  deleteCommunications,
  editCommunication,
  getCommunications,
} from "../../services/Communicationservices";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";
import { asCustomerList, getCustomers } from "../../services/customerService";
import { toastAlert } from "../../helpers/toastAlert";
import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import { hasPermission } from "../../utils/commonutils";

const CommunicationLogList = (props) => {
  const [tableData, setTableData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedData, setSelectedData] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ⭐ DELETE MODAL STATES
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  // ⭐ Pagination & Search
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchText, setSearchText] = useState("");

  const itemArray = () => [
    {
      name: "Communication Log",
      active: true,
      link: "",
    },
  ];

  const getCustomersList = async () => {
    const customers = await getCustomers(props , 1, 10000000);
    setCustomerData(asCustomerList(customers));
  };

const loadData = async () => {
  try {
    setLoading(true); // SHOW LOADER

    const response = await getCommunications(
      props,
      currentPage,
      rowsPerPage,
      searchText
    );

    const tbl = await CommunicationLogListData(
      response?.data?.items || [],
      {
        onEdit: handleEdit,
        onDelete: openDeleteModal,
      }
    );

    setTableData(tbl);
    setTotalRows(response?.data?.total || 0);

  } catch (err) {
    toastAlert("Something went wrong while loading communications", "error");
  } finally {
    setLoading(false); // HIDE LOADER
  }
};


  const handleAdd = () => {
    setSelectedData(null);
    setModalMode("add");
    setModalOpen(true);
  };

  const handleEdit = (row) => {
    setSelectedData(row);
    setModalMode("edit");
    setModalOpen(true);
  };

  // ⭐ OPEN DELETE CONFIRM MODAL
  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteCommunications(deleteId, props);
      toastAlert("Communication deleted successfully", "success");
      setShowDeleteModal(false);
      setDeleteId("");
      loadData();
    } catch (err) {
      toastAlert("Delete failed", "error");
    }
  };

  const handleSubmit = async (formData) => {
    try {
      let response;
      if (modalMode === "add") {
        response = await addCommunication(props, formData);
        if (response?.data?.code === 200 || response?.data?.code === 201) toastAlert("Communication added successfully", "success");
      } else {
        response = await editCommunication(props, formData, selectedData._id);
        if (response?.code === 200) toastAlert("Communication updated successfully", "success");
      }
      setModalOpen(false);
      loadData();
    } catch (err) {
      toastAlert("Something went wrong", "error");
    }
  };

  useEffect(() => {
    loadData();
    getCustomersList();
  }, [currentPage, rowsPerPage, searchText]);

  return (
    <div>
   <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  style={{ marginBottom: 16 }}
>
  {/* Breadcrumb : Left */}
  <Grid item>
    <BreadcrumbComp items={itemArray()} />
  </Grid>

  {/* Add Communication Button : Right */}
  {hasPermission("create_communication") && (
    <Grid item>
      <Button
        className="btn btn-colored"
        onClick={handleAdd}
      >
        + Add Communication
      </Button>
    </Grid>
  )}
</Grid>
      <Grid container className="data-table-main" mt={1}>
        <Grid item lg={12}>
          <div
            className="card-main"
            style={{ width: "100%", padding: 12, position: "relative" }}
          >
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: "60px",
                  left: "60px",
                  zIndex: 10,
                }}
              >
                <CircularProgress style={{ color: "#5F5BA8" }} size={35} />
              </div>
            )}

            <Datatable
              props={tableData}
              title="All Communication Log"
              currentPage={currentPage}
              TotalRow={totalRows}
              rowsPerPage={rowsPerPage}
              onPageChange={(page, rows) => {
                setCurrentPage(page);
                setRowsPerPage(rows);
              }}
              onSearchChange={(search) => {
                setSearchText(search);
                setCurrentPage(1);
              }}
            />
          </div>
        </Grid>
      </Grid>

      {modalOpen && (
        <CommunicationModal
          isOpen={modalOpen}
          mode={modalMode}
          communicationData={selectedData}
          onClose={() => setModalOpen(false)}
          onSubmit={handleSubmit}
          customerData={customerData}
        />
      )}

      {/* ⭐ DELETE CONFIRM MODAL */}
      <ConfirmDeleteModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this communication?"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(CommunicationLogList));
